"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPendingSalesAccountByCurrencySource = exports.getCostOfSalesAccountByCurrencySource = exports.getRevenueAccountByCurrencySource = exports.getSalesCreditCardAccountByCurrency = exports.getMerchantFeeAccountByCurrency = exports.getWHTAccountByCurrency = exports.getVATAccountByCurrency = exports.getCreditorAccountByCurrency = exports.getPaymentProviderAccountByCurrencyAndProvider = exports.getClientDebtorsAccountByCurrency = void 0;
const getClientDebtorsAccountByCurrency = (currency) => {
    switch (currency) {
        case "THB":
            return "76ed4ce4-c634-493e-94bc-50856c5175e8";
        case "USD":
            return "f3d48746-8367-46c6-84d1-2b6020bc6d6f";
    }
};
exports.getClientDebtorsAccountByCurrency = getClientDebtorsAccountByCurrency;
const getPaymentProviderAccountByCurrencyAndProvider = (currency, payment_type) => {
    switch (payment_type) {
        case "Credit_Card":
            switch (currency) {
                case "THB":
                    return "bbdc0967-db40-417e-ae94-a74668770892";
                case "USD":
                    return "90e70cb8-e604-435f-ac72-1bed5b231918";
                case "SGD":
                    return "94de42a4-62bb-455e-8012-04b72c21679d";
                case "MYR":
                    return "72bf4359-2600-449a-b2e4-bfa7842ea9e1";
            }
            break;
        case "Bank_Transfer":
            switch (currency) {
                case "THB":
                    return "81ebdc62-f2d3-4fee-9985-33f84eab59c5";
                case "USD":
                    return "02e962a8-6acb-4b50-b74d-41806d922076";
                case "SGD":
                    return "4c0a0660-e432-4902-84d5-99736a781546";
                case "MYR":
                    return "c81bbb1d-1035-4421-b1da-68bedc3f67d9";
            }
            break;
        default:
    }
};
exports.getPaymentProviderAccountByCurrencyAndProvider = getPaymentProviderAccountByCurrencyAndProvider;
// CREDITORS
const getCreditorAccountByCurrency = (currency, type) => {
    switch (currency) {
        case "THB":
            switch (type) {
                case "CADDIE":
                    return "bb5fb922-da51-4980-a806-ccb9148ce29c";
                case "CART":
                    return "2ac6dc85-63b4-4d29-b116-b4334f1e726a";
                case "GREEN_FEE":
                    return "42808a47-9ea1-49e4-94c4-ef6d4c05731c";
                case "CUSTOM":
                    return "7fd8f99e-1375-44be-be3d-1f8e4b3e34c4";
                case "HOTEL":
                    return "116f74d7-a6e1-47c8-b06f-4a17fa88e9cd";
                case "TRANSFER":
                    return "9bfefa0a-9264-4172-928e-04019d7b2a81";
            }
            break;
        case "USD":
            switch (type) {
                case "CADDIE":
                    return "fbb8802a-052f-4ce9-b5b9-31fa6899501d";
                case "CART":
                    return "f0ed8330-06bf-4a7c-b87c-adb0beeeb9dd";
                case "GREEN_FEE":
                    return "4586a826-2529-42f2-9c3f-095997ba5d1c";
                case "CUSTOM":
                    return "18d92bbb-4031-4d6a-aded-0bd9c0ac0ef4";
                case "HOTEL":
                    return "62512bcc-f3ab-4bf5-b7d7-c384bccc33a7";
                case "TRANSFER":
                    return "19a1f47a-1441-41b4-bfe4-9b622ab722a6";
            }
            break;
    }
};
exports.getCreditorAccountByCurrency = getCreditorAccountByCurrency;
const getVATAccountByCurrency = (currency) => {
    switch (currency) {
        case "THB":
            return "7957ff5e-1d1a-4ac9-b85e-c0a90d01f8aa";
        default:
            null;
    }
};
exports.getVATAccountByCurrency = getVATAccountByCurrency;
const getWHTAccountByCurrency = (currency) => {
    switch (currency) {
        case "THB":
            return "5a1f69bb-8cd6-4641-bd4c-5be28f2bad8d";
        default:
            null;
    }
};
exports.getWHTAccountByCurrency = getWHTAccountByCurrency;
const getMerchantFeeAccountByCurrency = (currency) => {
    switch (currency) {
        case "THB":
            return "d4ae4dee-aa2c-4cc2-ae35-6a14fa8289ce";
        case "USD":
            return "a1514885-daaa-4e7f-ae97-d30ab12c5da0";
    }
};
exports.getMerchantFeeAccountByCurrency = getMerchantFeeAccountByCurrency;
const getSalesCreditCardAccountByCurrency = (currency) => {
    switch (currency) {
        case "THB": {
            return "730ee62d-f1b4-438c-93d9-1df82e168f76";
        }
        case "USD": {
            return "c782b98b-8286-4442-a625-8337c454b1a1";
        }
    }
};
exports.getSalesCreditCardAccountByCurrency = getSalesCreditCardAccountByCurrency;
const getRevenueAccountByCurrencySource = (currency, source) => {
    switch (currency) {
        case "THB": {
            switch (source) {
                case "DIRECT":
                    return "c6e0dd9f-c546-4e4b-a4e2-c949b04f5f5e"; // 419
                case "GOLFSAVERS":
                    return "62187a32-c4ba-4827-908a-730f1f1b4185"; // 410
                case "AGS":
                    return "766514ba-6919-4563-8fba-186d02f4ccfb"; // 418
                case "GOLF_PATTAYA":
                    return "4c78ca8e-d93f-4ba8-b0b0-ad1c3f3bd987"; // 412
                case "GOLF_CHIANG_MAI":
                    return "edd0e1e4-2f31-4e24-9747-9958ed36da48"; // 413
                case "GOLF_HUA_HIN":
                    return "db5ef7e7-780d-4094-96a2-b01ab8f87f47"; // 411
                case "GOLF_PHUKET":
                    return "599fa7a6-41a4-46d6-8f67-35e16cebdb8f"; // 415
                case "GOLF_BANGKOK":
                    return "abe2ecce-5dc3-4e55-941a-db58c92ad6cd"; // 414
            }
            break;
        }
        case "USD": {
            switch (source) {
                case "DIRECT":
                    return "0de96270-ec67-47d3-8d97-c04c34b905b6";
                case "GOLFSAVERS":
                    return "ae67973b-7b71-4e6c-af6e-45c7f78659f0";
                case "GOLF_DUBAI":
                    return "5b3a0c8d-52b4-46f8-aed4-8df58a7147f3";
            }
        }
    }
};
exports.getRevenueAccountByCurrencySource = getRevenueAccountByCurrencySource;
const getCostOfSalesAccountByCurrencySource = (currency, source) => {
    switch (currency) {
        case "THB": {
            switch (source) {
                case "DIRECT":
                    return "a58bcb22-7da3-47e7-ab44-6980a2c99b1c"; // 519
                case "GOLFSAVERS":
                    return "32e1ae36-09ca-4d3c-931c-498f6f0ae882"; // 510
                case "AGS":
                    return "fcf889d0-9f6b-4a62-ae13-7cede33d4a8f"; // 514
                case "GOLF_PATTAYA":
                    return "0cef8151-59ae-4078-aba4-8e1eef5093b4"; // 512
                case "GOLF_CHIANG_MAI":
                    return "51eecc33-afcf-412a-9396-1d150b08d0af"; // 513
                case "GOLF_HUA_HIN":
                    return "0e36b1c2-8192-40d0-844d-83b456cd845e"; // 511
                case "GOLF_PHUKET":
                    return "a670e3da-9848-43d5-a03d-8aed5fd2e690"; // 515
                case "GOLF_BANGKOK":
                    return "b211a169-2461-48fb-8b62-c71e1a46050e"; // 514
            }
            break;
        }
        case "USD": {
            switch (source) {
                case "DIRECT":
                    return "1196c72c-5e19-4ae9-88de-b0ded6eb4add";
                case "GOLFSAVERS":
                    return "13f3f82d-7d96-4f37-ba11-3293d9d6a10c";
                case "GOLF_DUBAI":
                    return "feb527fa-a1c7-42b8-ae5f-db08dd169983";
            }
        }
    }
};
exports.getCostOfSalesAccountByCurrencySource = getCostOfSalesAccountByCurrencySource;
const getPendingSalesAccountByCurrencySource = (currency, source) => {
    switch (currency) {
        case "THB": {
            switch (source) {
                case "DIRECT":
                    return "c65071cc-6ca5-44b3-aa9f-8740a2449a92";
                case "GOLFSAVERS":
                    return "29731599-3675-4e96-b980-b9e2197e7852";
                case "AGS":
                    return "386d8a84-da17-4c00-adac-6f3d4ad91de1";
                case "GOLF_PATTAYA":
                    return "3958b9de-8f65-40ce-9ce3-ed93d528bdd4";
                case "GOLF_CHIANG_MAI":
                    return "35281bcf-b246-423d-8c7e-10729800cd22";
                case "GOLF_HUA_HIN":
                    return "16f95c89-87da-4cfc-9e5c-a316dcc2bf10";
                case "GOLF_PHUKET":
                    return "e74f79b5-11dd-496a-ba91-669aa3010f25";
                case "GOLF_BANGKOK":
                    return "53fc211b-8322-4bcb-a5d5-dc0efe236025";
            }
            break;
        }
        case "USD": {
            switch (source) {
                case "DIRECT":
                    return "f386eeef-5682-4716-a88d-62c2a68a8176";
                case "GOLFSAVERS":
                    return "074d2970-fc79-421a-9000-c31164a5d067";
                case "GOLF_DUBAI":
                    return "4590c281-f475-4f50-a7d5-315dbb7e5e25";
            }
        }
    }
};
exports.getPendingSalesAccountByCurrencySource = getPendingSalesAccountByCurrencySource;
